<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 "> {{ $t('fax') }} </label>
        <app-input 
            class="col-md-8"
            type="number" 
            v-model="selected" 
            min="6"
            :placeholder="$t('fax_phd')" />
    </div>
</template>
 
<script>
    export default {
        name: 'CustomerFax',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>